import { privateGet, privatePost } from "../clients/createPrivateClient";
import {
  CPCustomFormReportDocumentDetail,
  CPCustomFormReportDocumentListResponse,
  ReportDocumentLinkToSend,
} from "../models/unified";

export default {
  getDocumentDetail: async (id: string) => {
    const result = await privateGet<CPCustomFormReportDocumentDetail>(
      `customerPortal/customFormReportDocument/v2/${id}`,
    );

    return result;
  },
  getDocumentsByDays: async (days: number) => {
    const result = await privateGet<CPCustomFormReportDocumentListResponse>(
      `customerPortal/customFormReportDocument/v2/byDaysCreated/${days}`,
    );

    return result;
  },
  getDocumentsByOrderId: async (orderId: string) => {
    const result = await privateGet<CPCustomFormReportDocumentListResponse>(
      `customerPortal/customFormReportDocument/v2/byOrderId/${orderId}`,
    );

    return result;
  },
  sendByEmail: async (params: {
    reportDocumentId: string;
    values: ReportDocumentLinkToSend;
  }) => {
    const result = await privatePost<undefined>(
      `customerPortal/customFormReportDocument/v2/SendReportDocumentLink/${params.reportDocumentId}`,
      params.values,
    );

    return result;
  },
};
